/* eslint-disable max-len */
// TODO IDEA WHAT ARE THESE...HALP
// should those FAILS be prefixed FETCH_ and SAVE_
// ...something to think about when collisions happen
// CLEAR is conceptually REMOVE_ALL
const fetchActions = ['FETCH', 'RECEIVE', 'FAIL', 'FETCH_FAIL'];
const exportActions = ['EXPORT', 'EXPORT_SUCCESS', 'EXPORT_FAIL'];
const importActions = ['IMPORT', 'IMPORT_SUCCESS', 'IMPORT_FAIL'];
const saveActions = ['SAVE', 'RESULT', 'FAIL'];
const binaryActions = ['SET', 'CLEAR'];

function createTypes(base, actionsArray = fetchActions) {
  const res = {};
  actionsArray.forEach(type => {
    res[type] = `${base}_${type}`;
  });
  return res;
}

export const NAVIGATE = 'NAVIGATE';
export const START = 'START';
export const LOAD_PAGE = 'LOAD_PAGE';
export const DEBUG = 'DEBUG';
export const LOCALE = createTypes('LOCALE', binaryActions);

/* ---------- LOGIN / AUTH ---------- */
export const LOGIN = createTypes('LOGIN', [
  'CLIENT',
  'COMPANY',
  'TOKEN',
  'TOKENCHECKED',
]); // general login
export const CLIENT = createTypes('CLIENT', [...binaryActions, 'LOGIN']); // zeckit login
export const AUTH = createTypes('AUTH', [
  ...fetchActions,
  ...binaryActions,
  'INVALID',
]); // bank auth
export const PERMISSION = 'PERMISSION';

/* ---------- REPORT ---------- */
export const REPORT = createTypes('REPORT', [
  ...fetchActions,
  ...binaryActions,
  ...saveActions,
]);

/* ---------- LICENSES ---------- */
export const LICENSES = createTypes('LICENSES', [
  ...fetchActions,
  ...exportActions,
  ...importActions,
  'LIST', 'LIST_SUCCESS', 'LIST_FAIL',
]);
export const LICENSE_LOGS = createTypes('LICENSE_LOGS', [
  ...fetchActions,
  ...exportActions,
  ...importActions
]);
export const LICENSE = createTypes('LICENSE', [
  ...saveActions,
  'DEACTIVATE',
  'DEACTIVATE_FAIL',
  'DEACTIVATE_SUCCESS',
  'UPDATE',
  'UPDATE_FAIL',
  'UPDATE_SUCCESS',
  'UPGRADE',
  'UPGRADE_FAIL',
  'UPGRADE_SUCCESS',
]);
export const LICENSE_TYPES = createTypes(
  'LICENSE_TYPES', fetchActions
);
export const SELLERS = createTypes(
  'SELLERS', fetchActions
);
export const LICENSE_PAYMENTS = createTypes('LICENSE_PAYMENTS', [...fetchActions, ...saveActions]);
export const COMPANY_LICENSES = createTypes('COMPANY_LICENSES', fetchActions);

/* ---------- CONTACT PERSONS ---------- */
export const CONTACT_PERSONS = createTypes('CONTACT_PERSONS', fetchActions);
export const CONTACT_PERSON = createTypes('CONTACT_PERSON', [
  'ADD',
  'ADD_SUCCESS',
  'ADD_FAIL',
  'UPDATE',
  'UPDATE_FAIL',
  'UPDATE_SUCCESS',
]);

/* ---------- ACTION LOG ---------- */
export const ACTION_LOG = createTypes('ACTION_LOG', binaryActions);

/* ---------- LOCALITIES ---------- */
export const LOCALITIES = createTypes('LOCALITIES', [...fetchActions]);
export const REGIONS = createTypes('REGIONS', [...fetchActions]);

/* ---------- REVIEWS ---------- */
export const COMPANY_REVIEWS = createTypes('COMPANY_REVIEWS', [
  ...fetchActions,
  ...binaryActions,
]);
export const USER_REVIEWS = createTypes('USER_REVIEWS', [
  ...fetchActions,
  ...binaryActions,
]);
export const REVIEW = createTypes('REVIEW', [
  ...saveActions,
  ...binaryActions,
  ...fetchActions,
]);
export const TOP_REVIEWERS = createTypes('TOP_REVIEWERS', [...fetchActions]);
export const TOP_COMPANIES = createTypes('TOP_COMPANIES', [...fetchActions]);

/* ---------- PIACE ---------- */
export const PIACE = createTypes('PIACE', [...saveActions, ...fetchActions]);

/* ---------- EDITING ---------- */
export const REPORT_EDITABLE = createTypes('REPORT_EDITABLE', binaryActions);
export const EDITING = createTypes('EDITING', binaryActions);

/* ---------- CHAT ---------- */
export const CHAT = createTypes('CHAT', [
  ...fetchActions,
  ...saveActions,
  'START',
  'LIST',
  'RECEIVELIST',
]);

/* ---------- PORTFOLIO ---------- */
export const PORTFOLIO = createTypes('PORTFOLIO', [
  ...fetchActions,
  ...saveActions,
  'UPLOAD_IMAGE',
  'UPDATE_IMAGE',
  'RECEIVE_IMAGE',
  'ADD_SLIDE',
  'REMOVE_SLIDE',
  'UPDATE_FIELD',
  'UPLOAD_LOGO',
  'RECEIVE_LOGO',
  'UPDATE_COMPANY_FIELD',
  'RECOVER_SLIDES',
  'ENABLE',
  'DISABLE',
  'RECEIVE_ENABLE',
  'SHOW',
  'HIDE',
]);

/* ---------- PAID FEATURES --------- */
export const PAID = createTypes('PAID', [
  ...fetchActions,
  ...saveActions,
  'UPDATE_KEYWORDS',
  'SAVE_KEYWORDS',
  'RECEIVE_KEYWORDS',
  'FETCH_KEYWORDS',
  'SAVE_COMPANY_REGIONS',
  'FAIL_SAVE_COMPANY_REGIONS',
  'RECEIVE_COMPANY_REGIONS',
  'FETCH_COMPANY_REGIONS',
]);

/* ---------- RELIABLE PARTNER --------- */
export const RP_QUICK_CHECK = createTypes('RP_QUICK_CHECK', fetchActions);

/* ---------- CL REPORTS --------- */
export const CL_REPORT = createTypes('CL_REPORT', fetchActions);
